module.exports = __webpack_public_path__ + "static/media/techref.06027c82.png";